import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CaasContentService } from '../../services/caas-content.service';
import { NavigationService } from '../../services/navigation.service';
import {
  CaasError404,
  CaasLayout,
} from '../../../../hdi-components/src/shared/interfaces/caas/caas.interface';
import { ImageService } from '../../services/image.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
  errorContent?: CaasError404;
  seoRoute: string = '';
  errorCode?: '404' | '500';
  breadcrumbs: { title: string; url: string }[] = [
    { title: 'Startseite', url: '/' },
  ];
  pageIdentifier: string | undefined;

  constructor(
    private caasContentService: CaasContentService,
    private navigationService: NavigationService,
    private route: ActivatedRoute,
    private imageServices: ImageService
  ) {}

  ngOnInit(): void {
    this.pageIdentifier = this.route.snapshot.data['pageIdentifier'] || '';
    this.errorCode = this.route.snapshot.data['errorCode'] || '404';
    this.loadErrorContent();
    this.setSeoRoute();
    this.setBreadcrumbs();
  }

  private loadErrorContent(): void {
    if (!this.pageIdentifier) {
      console.error('Page identifier not found for error');
      return;
    }

    this.caasContentService.getContent(this.pageIdentifier).subscribe({
      next: (layouts: CaasLayout[]) => {
        const errorLayout = layouts.find(
          (layout) =>
            layout.name.includes('error') ||
            layout.name.includes('404') ||
            layout.name.includes('500')
        );

        if (errorLayout && errorLayout.children?.length) {
          this.errorContent = errorLayout.children[0] as CaasError404;
          this.imageServices.replaceErrorImage(this.errorContent);
        } else {
          console.warn('Error layout not found in CAAS content');
        }
      },
      error: (err) => {
        console.error('Error loading CAAS content', err);
      },
    });
  }

  private setSeoRoute(): void {
    this.navigationService.getNavigation().subscribe((navigation) => {
      if (this.pageIdentifier) {
        this.seoRoute =
          this.navigationService.getSeoRouteByIdentifier(
            this.pageIdentifier,
            navigation
          ) || 'error';
      }
    });
  }

  private setBreadcrumbs(): void {
    if (this.seoRoute) {
      this.navigationService.getNavigation().subscribe((navigation) => {
        this.breadcrumbs = this.navigationService.generateBreadcrumbs(
          this.seoRoute,
          navigation
        );
      });
    } else {
      this.breadcrumbs = [{ title: 'Error', url: '/error' }];
    }
  }
}
